<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <v-alert
        color="purple darken-2"
        type="warning"
        icon="mdi-hand-back-left"
        prominent
        text
        class="rounded-bl-0 rounded-br-0"
      >
        <h5>{{ $t('forms.info.modifyVinculationForm.title') }}</h5>
        <div v-html="$t('forms.info.modifyVinculationForm.message')"></div>
        <v-divider
          class="my-4 info"
          style="opacity: 0.22"
        ></v-divider>
        <v-row>
          <v-col
            class="text-center"
            justify="space-around"
          >
            <v-btn
              color="purple darken-4"
              outlined
              :to="`/researchers/${processData.object_id}/forms/vinculationForm`"
            >
              {{ $t('forms.info.modifyVinculationForm.button') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-form
        class="pa-6"
        ref="form"
        :key="form_name"
        v-if="investigatorVinculations.length > 0"
      >
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="vinculationSelected"
              :items="investigatorVinculations"
              :item-text="getLargeVinculationName"
              :label="$t('label.vinculation_to_extend')"
              return-object
              outlined
              :readonly="disabledForm"
              :rules="rules.fieldRequired"
              hide-details
              @change="changeVinculation($event)"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-checkbox
                    :label="$t('form.add.expiration_date')"
                    v-model="extend_expiration_date"
                    :readonly="disabledForm"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
                    :label="$t('form.add.workplace_date')"
                    v-model="extend_workplace_assignation_date"
                    :readonly="disabledForm"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="menu_end_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="vinculationSelected.end_date"
                  :label="$t('label.endDate')"
                  prepend-inner-icon="event"
                  readonly
                  outlined
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="vinculationSelected.end_date"
                :min="vinculationSelected.start_date"
                @input="menu_end_date = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-divider />
        <v-container>
          <UserFormActions
            form_name_text="Modify vinculation"
            :form_name="form_name"
            :ref-form="$refs.form"
            :object_type="object_type"
            :data="processData"
            :state="state"
            @change-state="changeState"
          />
        </v-container>
      </v-form>
      <div v-else class="pa-6">
        <v-alert dense text type="error" class="without-margin-bottom">
          {{ $t("investigator.no.vinculationExtend") }}
        </v-alert>
        <v-btn text @click="$router.go(-1)">{{ $t("button.back") }}</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import investigatorData from "../../../mixins/investigator_data";
export default {
  mixins: [changeState, validationRules, investigatorData],
  components: { RejectCommentLayout, UserFormActions },

  data: () => ({
    form_name: "modifyVinculationForm",
    menu_end_date: false,
    object_type: "investigator",
    state: "",
    reject_comment: "",
    vinculationSelected: "",
    investigatorVinculations: [],
    extend_expiration_date: true,
    extend_workplace_assignation_date: true
  }),

  mounted() {
    this.getData();
  },

  computed: {
    updateVinculationForm() {
      return this.$route.meta.updateForm;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },

    processData() {
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            vinculation: {
              id: this.vinculationSelected.id,
              end_date: this.vinculationSelected.end_date
            },
            extend_expiration_date: this.extend_expiration_date,
            extend_workplace_assignation_date: this.extend_workplace_assignation_date
          }
        }
      };
    }
  },

  methods: {
    getLargeVinculationName(vinculation) {
      return (
        vinculation.category.internal_name +
        " | " +
        this.$t("vinculation.types." + vinculation.type) +
        " | " +
        vinculation.start_date
      );
    },
    getLastVinculation(form_data) {
      if (form_data) {
        this.vinculationSelected = this.investigatorVinculations.find(vinculation => vinculation.id === this.investigator.vinculation.id)
        this.vinculationSelected.end_date = this.investigator.vinculation.end_date
      } else {
        if (typeof this.investigator.vinculation.category == "number") {
          this.investigatorVinculations.forEach(vinculation => {
            if (
                    this.investigator.vinculation.category === vinculation.category.id
            ) {
              this.vinculationSelected = vinculation;
            }
          });
        } else {
          this.investigatorVinculations.forEach(vinculation => {
            if (
                    this.vinculationSelected === "" ||
                    this.vinculationSelected.end_date < vinculation.end_date
            ) {
              this.vinculationSelected = vinculation;
            }
          });
        }
      }
    },
    getInvestigatorVinculations(id, form_data) {
      let path = this.$store.state.endpoint + "/vinculation/person/" + id;
      axios
        .get(path)
        .then(response => {
          response.data.forEach(responseVinculation => {
            if (
              this.investigatorVinculations.some(
                investigatorVinculation =>
                  investigatorVinculation.category.id ===
                  responseVinculation.category.id
              )
            ) {
              let vinculation = this.investigatorVinculations.find(
                x => x.category.id === responseVinculation.category.id
              );
              if (vinculation.end_date < responseVinculation.end_date) {
                this.investigatorVinculations.splice(
                  this.investigatorVinculations.indexOf(vinculation),
                  1
                );
                this.investigatorVinculations.push(responseVinculation);
              }
            } else {
              this.investigatorVinculations.push(responseVinculation);
            }
          });
          this.getLastVinculation(form_data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getData() {
      let path = "";
      if (this.updateVinculationForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.vinculation = response.data.data.user.vinculation;
            this.extend_expiration_date = response.data.data.user.extend_expiration_date;
            this.extend_workplace_assignation_date = response.data.data.user.extend_workplace_assignation_date;
            this.state = response.data.state;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(
              this.$store.state.endpoint + "/person/" + this.investigator.id
            );
            this.getInvestigatorVinculations(this.investigator.id, true);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorName(
          this.$store.state.endpoint + "/person/" + this.$route.params.id
        );
        this.getInvestigatorVinculations(this.$route.params.id, false);
      }
    },

    changeVinculation(vinculationSelect) {
      this.investigatorVinculations.forEach(vinculation => {
        if (vinculation.category.id === vinculationSelect.category.id) {
          this.vinculationSelected = vinculation;
        }
      });
    }
  }
};
</script>
